function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from 'react';
import PropTypes from 'prop-types';
import APInput from '../APInput';
import cryptoAddressValidator from '../../../helpers/cryptoAddressValidationHelper/cryptoAddressValidationHelper';
var APCryptoAddressInputComponent = function APCryptoAddressInputComponent(props, context) {
  var productSymbol = props.productSymbol,
    otherProps = _objectWithoutProperties(props, ['productSymbol']);
  var errorMessage = context.t('Invalid {productSymbol} address', {
    productSymbol: productSymbol
  });
  var validator = cryptoAddressValidator(productSymbol, errorMessage);
  return React.createElement(APInput, Object.assign({}, otherProps, {
    validate: validator
  }));
};
APCryptoAddressInputComponent.propTypes = Object.assign({
  productSymbol: PropTypes.string.isRequired
}, APInput.propTypes);
APCryptoAddressInputComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default APCryptoAddressInputComponent;